import Icon from 'vue-awesome/components/Icon'

Icon.register({
  beach_access_sharp: {
    paths: [
      {
        d: 'M5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98zm11.47 2.85l2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88z'
      },
      {
        d: 'M5.97 5.96l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3zm7.156 8.6l1.428-1.428 6.442 6.442-1.429 1.428z'
      }
    ],
    width: '24',
    height: '24'
  }
})
